export default __webpack_public_path__ + "static/media/cp_geo_fm.0c77bf24.svg";